// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { HorizontalOperationsNav } from './ui/index.tsx';
import type { OverviewNav } from './ui/overview/index.tsx';

export const LazyHorizontalOperationsNav: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof HorizontalOperationsNav
>(
	() =>
		import(/* webpackChunkName: "jira-operations-horizontal-nav" */ './ui/index.tsx').then(
			({ HorizontalOperationsNav }) => HorizontalOperationsNav,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const LazyHorizontalOperationsOverviewNav: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof OverviewNav>(
		() =>
			import(
				/* webpackChunkName: "jira-operations-horizontal-overview-nav" */ './ui/index.tsx'
			).then(({ OverviewNav }) => OverviewNav),
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	);

export const AsyncHorizontalOperationsNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-operations-nav" fallback={null}>
		<JSErrorBoundary
			id="asyncHorizontalOperationsNav"
			packageName="jiraOperationsHorizontalNav"
			fallback="flag"
			teamName="alexstrasza"
		>
			<LazyHorizontalOperationsNav />
		</JSErrorBoundary>
	</Placeholder>
);

export const AsyncHorizontalOperationsOverviewNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-operations-overview-nav" fallback={null}>
		<JSErrorBoundary
			id="asyncHorizontalOperationsOverviewNav"
			packageName="jiraOperationsHorizontalNav"
			fallback="flag"
			teamName="alexstrasza"
		>
			<LazyHorizontalOperationsOverviewNav />
		</JSErrorBoundary>
	</Placeholder>
);
